/** Announcement ids (must mirror the API allowlist in whats-new.const.ts). */
export const CLUB_LAUNCH_ID = 'club-launch';

export const WHATS_NEW_IDS = ['club-launch'] as const;

export type TWhatsNewId = (typeof WHATS_NEW_IDS)[number];

/** Query param used to force-preview an announcement (`?whatsNew=<id>`). */
export const WHATS_NEW_QUERY = 'whatsNew';

/** vue-js-modal dialog name shared by the host and the modal components. */
export const WHATS_NEW_MODAL_NAME = 'v2-whats-new';
